export default "__VITE_ASSET__62183219__"